// extracted by mini-css-extract-plugin
export default {"container":"compare-checkbox__container___2WBh2","compare-container":"compare-checkbox__compare-container___3iS7i","select-more":"compare-checkbox__select-more___1dIi1"};